import type { LayerLegend } from "@/types/explore"

export const LEGENDS: Record<string, LayerLegend> = {
  argile: {
    type: "gradient",
    label: "Argile",
    items: [
      { color: "#fee090", label: "Faible" },
      { color: "#fdae61", label: "Moyen" },
      { color: "#d73027", label: "Fort" },
    ],
  },
  seisme: {
    type: "gradient",
    label: "Sismicite",
    items: [
      { color: "#E8E8E8", label: "Tres faible" },
      { color: "#FFFF73", label: "Faible" },
      { color: "#FFAA00", label: "Moderee" },
      { color: "#E60000", label: "Moyenne" },
      { color: "#730000", label: "Forte" },
    ],
  },
  radon: {
    type: "gradient",
    label: "Radon",
    items: [
      { color: "#ffffcc", label: "Faible" },
      { color: "#a1dab4", label: "Moyen" },
      { color: "#253494", label: "Fort" },
    ],
  },
  plu: {
    type: "items",
    label: "PLU",
    items: [
      { color: "#3b82f6", label: "U" },
      { color: "#93c5fd", label: "AUc" },
      { color: "#60a5fa", label: "AUs" },
      { color: "#16a34a", label: "N" },
      { color: "#ca8a04", label: "A" },
    ],
  },
  qpv: {
    type: "swatch",
    label: "QPV",
    items: [{ color: "#FF0000", label: "Quartier prioritaire" }],
  },
  inondation: {
    type: "gradient",
    label: "Inondation",
    items: [
      { color: "#7ECBA1", label: "Crue moy. probabilite" },
      { color: "#C6E7DC", label: "0 - 0,5 m" },
      { color: "#9DD3C0", label: "0,5 - 1 m" },
      { color: "#5BAEB0", label: "1 - 2 m" },
      { color: "#1A5276", label: "Plus de 2 m" },
    ],
  },
  ppri: {
    type: "items",
    label: "PPRI",
    items: [
      { color: "#6BAED6", label: "PPRN Inondation prescrit", shape: "square" },
      { color: "#3182BD", label: "PPRN Inondation approuve", shape: "square" },
    ],
  },
  pollution: {
    type: "items",
    label: "Pollution",
    items: [
      { color: "#E88DAE", label: "Sites industriels (loc.)", shape: "circle" },
      { color: "#F5A0B8", label: "Sites industriels (emprise)", shape: "square" },
      { color: "#F4A460", label: "Servitudes d'utilite publique", shape: "square" },
    ],
  },
  "isochrone-walk": {
    type: "gradient",
    label: "Isochrone pieton",
    items: [
      { color: "#22c55e", label: "10 min" },
      { color: "#f97316", label: "20 min" },
      { color: "#ef4444", label: "30 min" },
    ],
  },
  "isochrone-drive": {
    type: "gradient",
    label: "Isochrone voiture",
    items: [
      { color: "#22c55e", label: "10 min" },
      { color: "#f97316", label: "20 min" },
      { color: "#ef4444", label: "30 min" },
    ],
  },
  "isochrone-bike": {
    type: "gradient",
    label: "Isochrone velo",
    items: [
      { color: "#22c55e", label: "10 min" },
      { color: "#f97316", label: "20 min" },
      { color: "#ef4444", label: "30 min" },
    ],
  },
  "presc-ebc": {
    type: "swatch",
    label: "Espaces boises classes",
    items: [{ color: "#66C2A4", label: "Espaces boises classes" }],
  },
  "presc-er": {
    type: "swatch",
    label: "Emplacement reserve",
    items: [{ color: "#c34c94", label: "Emplacement reserve" }],
  },
  "presc-pdm": {
    type: "swatch",
    label: "Plan de masse",
    items: [{ color: "#FFA78F", label: "Plan de masse" }],
  },
  "presc-ric": {
    type: "swatch",
    label: "Implantation constructions",
    items: [{ color: "#253494", label: "Implantation constructions" }],
  },
  "presc-pms": {
    type: "swatch",
    label: "Mixite sociale",
    items: [{ color: "#ec823d", label: "Mixite sociale" }],
  },
  "presc-oap": {
    type: "swatch",
    label: "OAP",
    items: [{ color: "#33e0ff", label: "OAP" }],
  },
  "presc-emprise": {
    type: "swatch",
    label: "Emprise au sol",
    items: [{ color: "#1E40AF", label: "Emprise au sol" }],
  },
  "presc-hauteur": {
    type: "swatch",
    label: "Hauteur",
    items: [{ color: "#A3AED0", label: "Hauteur" }],
  },
  "presc-volumetrie": {
    type: "swatch",
    label: "Volumetrie",
    items: [{ color: "#1B2559", label: "Volumetrie" }],
  },
  "presc-stationnement": {
    type: "swatch",
    label: "Stationnement",
    items: [{ color: "#41B6C4", label: "Stationnement" }],
  },
  "info-zac": {
    type: "swatch",
    label: "ZAC",
    items: [{ color: "#FCC43E", label: "Zone d'amenagement concerte" }],
  },
  "info-zpens": {
    type: "swatch",
    label: "ZPENS",
    items: [{ color: "#FEB24C", label: "Zone de preemption ENS" }],
  },
  "info-dpu": {
    type: "swatch",
    label: "DPU",
    items: [{ color: "#FFE096", label: "Droit de preemption urbain" }],
  },
  "info-div-fonc": {
    type: "swatch",
    label: "Div. foncieres",
    items: [{ color: "#7FCDBB", label: "Divisions foncieres" }],
  },
  "info-sursis": {
    type: "swatch",
    label: "Sursis",
    items: [{ color: "#B34262", label: "Sursis a statuer" }],
  },
  "info-pae": {
    type: "swatch",
    label: "PAE",
    items: [{ color: "#1D91C0", label: "Programme d'amenagement" }],
  },
  "info-bruit": {
    type: "swatch",
    label: "Bruit",
    items: [{ color: "#FC814F", label: "Secteur affecte par le bruit" }],
  },
  "info-archeo": {
    type: "swatch",
    label: "Archeologie",
    items: [{ color: "#081D58", label: "Site archeologique" }],
  },
  "info-ppr": {
    type: "swatch",
    label: "PPR",
    items: [{ color: "#7BCCC4", label: "Plan de prevention des risques" }],
  },
  "info-peb": {
    type: "swatch",
    label: "PEB",
    items: [{ color: "#788d99", label: "Exposition au bruit aerodromes" }],
  },
  "info-taxe": {
    type: "swatch",
    label: "Taxe",
    items: [{ color: "#C95C3F", label: "Taxe d'amenagement" }],
  },
  "info-sis": {
    type: "swatch",
    label: "SIS",
    items: [{ color: "#1E40AF", label: "Information sur les sols" }],
  },
  "info-chaleur": {
    type: "swatch",
    label: "Reseau de chaleur",
    items: [{ color: "#46A097", label: "Reseau de chaleur", shape: "line" }],
  },
  "info-gares": {
    type: "swatch",
    label: "Gares",
    items: [{ color: "#1890FF", label: "Perimetre des gares", shape: "circle" }],
  },
}
